export default "__VITE_ASSET__BGnA61Mk__"